<template>
  <div :class="{ noScroll: searchkeylist.length }" class="searchItemList search">
    <div :class="{ searchkeylist: searchkeylist.length }">
      <header>
        <form action="/">
          <van-search
            :placeholder="defaultSearch ? '搜索“' + defaultSearch + '”' : ''"
            @cancel="cancel"
            @focus="input"
            @input="input"
            @search="search"
            clearable
            maxlength="32"
            show-action
            v-model="searchValue"
          ></van-search>
        </form>
      </header>
      <ul class="f12" v-if="searchkeylist.length">
        <li @click="searchkeyHandle(item)" class="over-ell-1" v-for="item of searchkeylist">
          {{ item }}
        </li>
      </ul>
    </div>
    <Scroller
      v-if="!nosearch"
      :is-refresh-data.sync="refresh"
      :is-loading-data.sync="loading"
      :is-finished-data.sync="finished"
      :no-data-text-data.sync="noDataText"
      @on-infinite="onInfinite"
      @on-refresh="onRefresh"
      class="my_scroller"
      ref="my_scroller"
    >
      <div class="newPerson" v-if="recommenditemlist && recommenditemlist.length > 0 && !nosearch">
        <div
          class="newPersonContent title"
          v-if="recommenditemlist && recommenditemlist.length > 0"
        >
          <p>
            <b>小编推荐进入</b>
            <span v-if="recommenditemlist.length && recommenditemlist.length > 3" @click="morelist">
              更多
              <van-icon name="arrow" size="10" color="#444648" />
            </span>
          </p>
          <ul>
            <li
              v-for="(item, index) of recommenditemlist.length > 3
                ? recommenditemlist.slice(0, 3)
                : recommenditemlist"
              @click="searchClick(item, { scenepoint: 'SEARCHRESULT', scenedesc: '小编推荐进入' })"
            >
              <img v-lazy="item.img_path" />
              <p>{{ item.name }}</p>
              <span>
                ￥{{ item.sales_price }}
                <i>￥{{ item.cost_price }}</i>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="list" v-if="list && list.length > 0">
        <p class="van-divider">搜索结果</p>
        <ul>
          <li
            v-for="(item, index) of list"
            :key="index"
            @click="searchClick(item, { scenepoint: 'SEARCHRESULT', scenedesc: '搜索结果' })"
          >
            <div class="pos-r img">
              <img class="w-100 h-100" v-lazy="item.img_path" />
              <img
                src="/static/images/shouqing.png"
                class="soldout pos-a"
                v-if="item.islimit == 2"
              />
              <img :src="item.topTagImg" class="pos-a ad_1 ad_1_top" v-if="item.topTagImg"/>
              <img :src="item.bottomTagImg" class="pos-a ad_1 ad_1_bottom" v-if="item.bottomTagImg"/>
            </div>
            <div class="content">
              <p>
                {{ item.name.length > 26 ? item.name.slice(0, 26) + '...' : item.name }}
                <img v-if="item.property === 'overseas'" src="../../assets/images/haiwai.png" />
              </p>
              <div class="evaluation">
                <b>
                  已售{{
                    parseFloat(item.sales_num) / 10000 >= 1
                      ? (parseInt(parseInt(item.sales_num) / 100) / 100).toFixed(2) + 'w'
                      : item.sales_num
                  }}
                </b>
                <b>
                  好评{{
                    parseFloat(item.comment_num) / 10000 >= 1
                      ? (parseInt(parseInt(item.comment_num) / 100) / 100).toFixed(2) + 'w'
                      : item.comment_num
                  }}
                </b>
              </div>
              <span>
                <span class="smallprice">
                  <sub>¥</sub>
                  <b
                    v-text="
                      String(item.sales_price).slice(0, String(item.sales_price).indexOf('.'))
                    "
                  ></b>
                  <sup
                    v-text="
                      String(item.sales_price).slice(
                        String(item.sales_price).indexOf('.'),
                        String(item.sales_price).length
                      )
                    "
                  ></sup>
                </span>
                <i>￥{{ item.cost_price }}</i>
              </span>
            </div>
          </li>
        </ul>
      </div>
    </Scroller>
    <div v-if="nosearch" class="nodata" style="margin-top: 0.1rem">
      <img src="../../assets/images/nosearch.png" />
      <div class="msg">啊哦，没有搜索到商品</div>
      <div class="gobtn" @click="goList">去逛逛</div>
    </div>
    <div class="newPerson" v-if="recommenditemlist && recommenditemlist.length > 0 && nosearch">
      <div class="newPersonContent title">
        <p>
          <b>小编推荐进入</b>
          <span v-if="recommenditemlist.length && recommenditemlist.length > 3" @click="morelist">
            更多
            <van-icon name="arrow" size="10" color="#444648" />
          </span>
        </p>
        <ul>
          <li
            v-for="(item, index) of recommenditemlist.length > 3
              ? recommenditemlist.slice(0, 3)
              : recommenditemlist"
            @click="searchClick(item, { scenepoint: 'SEARCHRESULT', scenedesc: '小编推荐进入' })"
          >
            <img v-lazy="item.img_path" />
            <p>{{ item.name }}</p>
            <span>
              ￥{{ item.sales_price }}
              <i>￥{{ item.cost_price }}</i>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div
      v-if="guessList && guessList.length > 0"
      style="padding: 0.15rem 0.11rem 0; background: #fff"
    >
      <product-list
        :title="title"
        :productlist="guessList"
        :markPointData="{ scenepoint: 'SEARCHRESULT', scenedesc: title }"
      ></product-list>
    </div>
  </div>
</template>

<script>
import { isWeixin, kefu, fenxiang, Base64 } from '../../assets/common/js/config'
import empty from '../emptypage/empty'
import Scroller from '../common/Scroller'
import productList from '../common/productList'
import aes from '../../axiosApi/encrypt'
export default {
  name: 'searchItemList',
  data() {
    return {
      list: [],
      recommenditemlist: [],
      defaultSearch: '',
      historyList: [],
      nosearch: false,
      searchValue: '',
      searchType: null,
      guessList: [],
      title: '发现好物',
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——',
      searchkeylist: []
    }
  },
  components: {
    empty,
    Scroller,
    productList
  },
  mounted: function () {
    window.scrollTo(0, 0)
    if (this.$route.query.searchval) {
      this.searchValue = decodeURIComponent(this.$route.query.searchval)
      this.searchType = this.$route.query.searchType
    }
    if (this.searchValue !== '') {
      this.noRepeat()
    }
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/' && from.name != 'homePage') {
      // 当前页面刷新不需要切换位置
      next((vm) => {
        vm.nowPage = 0
      })
    } else {
      next((vm) => {
        if (from.path != '/productdetail') Object.assign(vm.$data, vm.$options.data())
        if (vm.$route.query.searchval) {
          vm.searchValue = decodeURIComponent(vm.$route.query.searchval)
        }
        if (vm.searchValue !== '') {
          vm.noRepeat()
        }
        // vm.nowPage = 1
        // vm.getData()
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    //记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    if (to.path != '/productdetail') this.loading = true
    next()
  },
  methods: {
    getData: function () {
      this.defaultSearch = this.$store.state.defaultSearch || ''
      var base = new Base64()
      const keyword = aes.replaceAES(base.encode(this.searchValue))
      var url =
        this.$ajax.getSearchList_URL +
        '?pageno=' +
        this.nowPage +
        '&pagesize=' +
        this.pagesize +
        '&keyword=' +
        keyword
      var that = this
      that.$customRequestAjax(url).then(function (res) {
        if (res.data.code === 200) {
          that.recommenditemlist = res.data.recommenditemlist
          if (that.nowPage === 1) {
            that.list = res.data.itemlist
            if (that.list.length <= 0) {
              that.nosearch = true
            } else {
              that.nosearch = false
            }
            that.refresh = false
          } else {
            that.list = that.list.concat(res.data.itemlist)
          }
          that.loading = false
          if (res.data.itemlist.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
          if (that.list.length <= 0) {
            that.guessList = res.data.favoriteitemlist
          } else {
            that.guessList = []
          }
          if (isWeixin()) {
            fenxiang({ path: 'searchitemlist' })
          }
          that.dataCollection('searchSuccess')
        }
      })
    },
    searchkeyHandle: function (item) {
      this.searchkeylist = []
      this.searchValue = item
      this.search()
    },
    input: function () {
      this.$customRequestAjax(this.$ajax.getNameByKey_URL + '?keyword=' + this.searchValue).then(
        (res) => {
          if (res.data.code === 200) {
            this.searchkeylist = res.data.list
          }
        }
      )
    },
    cancel: function () {
      this.$router.go(-1)
    },
    noRepeat: function () {
      if (
        localStorage.getItem('historylist') !== null &&
        localStorage.getItem('historylist') !== undefined &&
        localStorage.getItem('historylist') !== ''
      ) {
        this.historyList = JSON.parse(localStorage.getItem('historylist'))
        var historyArr = []
        var obj = {}
        this.historyList.unshift(this.searchValue)
        for (var i of this.historyList) {
          if (!obj[i]) {
            historyArr.push(i)
            obj[i] = 1
          }
        }
        if (historyArr.length > 20) {
          historyArr.splice(historyArr.length - 1, 1)
          localStorage.setItem('historylist', JSON.stringify(historyArr))
        } else {
          localStorage.setItem('historylist', JSON.stringify(historyArr))
        }
      } else {
        this.historyList.unshift(this.searchValue)
        localStorage.setItem('historylist', JSON.stringify(this.historyList))
      }
    },
    goList: function () {
      this.$router.push({
        path: '/classification',
        query: {
          type: 'inside'
        }
      })
    },
    morelist: function () {
      this.$router.push({
        path: '/recommendlist',
        query: {
          searchval: encodeURIComponent(this.searchValue)
        }
      })
    },
    search: function () {
      if (this.searchValue !== '') {
        this.searchkeylist = []
        this.noRepeat()
        this.nowPage = 1
        this.list = []
        this.onRefresh()
      } else {
        if (this.defaultSearch) {
          this.searchkeylist = []
          this.searchValue = this.defaultSearch
          this.noRepeat()
          this.nowPage = 1
          this.list = []
          this.onRefresh()
        } else {
          this.$toast('请正确输入查询内容')
        }
      }
    },
    searchClick: function (items, markPointData) {
      this.dataCollection('searchResultsClick', items)
      this.$router.replace({
        path: '/searchlist',
        query: {
          searchval: encodeURIComponent(this.searchValue)
        }
      })
      let data = markPointData
      data.itemid = items.itemid
      this.$clickburiedPoint({
        url: 'ckysdatacenter/itemclick/save',
        data: data
      })
      this.$router.push({
        path: '/productdetail',
        query: {
          itemid: items.itemid
        }
      })
    },
    dataCollection(dataType, productInfo) {
      let searchTypeInfo = {
          0: '手动搜索',
          1: '历史搜索',
          2: '热门搜索'
        },
        params
      if (dataType == 'searchSuccess') {
        params = {
          searchWord_var: this.searchValue, // 搜索词
          searchSource_var: searchTypeInfo[this.searchType], // 搜索词来源
          ifSearchResult_var: this.nosearch ? '无' : '有'
        }
        // 埋点-转化变量-搜索效果评估
        let value = this.searchValue
        gio('evar.set', 'flowArea_evar', '搜索')
        gio('evar.set', 'searchWords_evar', value)
      } else {
        params = {
          searchWord_var: this.searchValue, // 搜索词
          searchSource_var: searchTypeInfo[this.searchType], // 搜索词来源
          productId_var: productInfo.itemid, // 商品id
          productName_var: productInfo.name, // 商品名称
          firstCat_var: '', // 商品一级分类
          productType_var: '' // 商品分类
        }
      }
      gio('track', dataType, params)
    },
    onRefresh() {
      this.refresh = true
      this.nowPage = 1
      this.getData()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      var that = this
      that.nowPage++
      that.getData()
    }
  }
}
</script>

<style scoped lang="scss">
.title > p,
.title > p > span,
.newPerson > .newPersonContent > ul > li > span {
  display: flex;
  justify-content: space-between;
}
.newPerson > .newPersonContent > ul {
  display: flex;
}
.searchItemList {
  display: flex;
  flex-direction: column;
  ._v-container {
    padding-top: 0.45rem;
    background: #fff;
  }
  .nosearch {
    flex: 1;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
}
header {
  position: relative;
  z-index: 2;
  padding: 0 0.11rem 0;
  padding-right: 0.03rem;
  background: #fff;
}
.list {
  background: #fff;
  padding-top: 0.15rem;
  ul {
    background: #fff;
    li {
      padding: 0.1rem 0.11rem 0;
      display: flex;
      &:last-of-type {
        padding-bottom: 0.1rem;
      }
      > img {
        width: 1.22rem;
        height: 1.22rem;
      }
      .img {
        width: 1.22rem;
        height: 1.22rem;
        .soldout {
          width: 59%;
          height: 59%;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
        .ad_1 {
          width: 0.43rem;
          height: auto;
          right: 0;
        }
        .ad_1_top {
          top: 0.32rem;
        }
        .ad_1_bottom {
          bottom: 0.22rem;
        }
      }
      .content {
        margin-left: 0.07rem;
        padding-top: 0.08rem;
        flex: 1;
        position: relative;
        > p {
          font-size: 0.14rem;
          font-weight: 400;
          color: rgba(41, 41, 41, 1);
          line-height: 0.2rem;
          max-height: 0.4rem;
          overflow: hidden;
          img {
            width: 0.19rem;
            height: 0.19rem;
            display: inline;
            position: relative;
            top: 0.04rem;
            left: 0.04rem;
          }
        }
        .evaluation {
          margin-top: 0.12rem;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          b {
            font-size: 0.11rem;
            color: #6c6c6c;
            font-weight: 400;
            &:last-of-type {
              margin-left: 0.25rem;
            }
          }
        }
        > span {
          display: flex;
          align-items: center;
          margin-top: 0.27rem;
          position: absolute;
          bottom: 0.08rem;
          i {
            display: block;
            font-size: 0.1rem;
            font-weight: 600;
            color: #2e2e2e;
            line-height: 14px;
            font-style: normal;
            text-decoration: line-through;
            margin-left: 0.05rem;
          }
          .smallprice {
            font-size: 0;
            color: #fc0324;
            b {
              font-size: 0.17rem;
              line-height: 0.2rem;
              font-weight: 600;
            }
            sub {
              font-weight: 600;
              font-size: 0.12rem;
              vertical-align: baseline;
            }
            sup {
              font-size: 0.12rem;
              vertical-align: baseline;
              font-weight: 600;
            }
          }
        }
      }
    }
  }
}
.van-divider {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  width: 60%;
  margin: 0 auto;
  line-height: 24px;
  border-color: #dbdbdb;
  border-style: solid;
  border-width: 0;
  color: #222222;
  font-weight: 400;
}
.van-divider::before,
.van-divider::after {
  content: ' ';
  display: block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  box-sizing: border-box;
  height: 1px;
  border-color: inherit;
  border-style: inherit;
  border-width: 1px 0 0;
  margin-right: 16px;
  margin-left: 16px;
}
.title {
  p {
    font-size: 0.18rem;
    color: #222222;
    span {
      height: 0.16rem;
      padding-left: 0.06rem;
      padding-right: 0.01rem;
      border: 0.01rem solid #6c6c6c;
      border-radius: 0.08rem;
      font-size: 0.1rem;
      align-items: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      color: #6c6c6c;
      img {
        margin-left: 0.04rem;
        display: block;
        width: 0.03rem;
        height: 0.06rem;
      }
    }
  }
}
.newPerson {
  padding: 0.1rem 0;
  .newPersonContent {
    background: #fff;
    background-size: 100% 100%;
    padding-bottom: 0.07rem;
    p {
      align-items: center;
      padding: 0.1rem 0.07rem;
      font-weight: 500;
      b {
        font-weight: 400;
        color: #222222;
      }
    }
    ul {
      padding: 0 0.07rem;
      li {
        width: 1.14rem;
        position: relative;
        background: #fefffe;
        border-radius: 0.04rem;
        margin-right: 0.07rem;
        &:last-of-type {
          margin-right: 0;
        }
        .tags {
          font-size: 0.09rem;
          color: #fe0d0d;
          height: 19px;
          background: #fef1f2;
          border-radius: 0 1rem 1rem 0;
          position: absolute;
          left: 0;
          top: 0.07rem;
          padding: 0.03rem 0.06rem 0.03rem 0.09rem;
        }
        img {
          width: 1.14rem;
          height: 1.14rem;
          border-radius: 0.04rem 0.04rem 0 0;
        }
        p {
          font-size: 0.11rem;
          color: #292929;
          padding: 0.03rem 0.03rem 0;
          text-align: center;
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        span {
          color: #fc0324;
          font-size: 0.11rem;
          justify-content: center;
          padding-bottom: 0.07rem;
          i {
            display: block;
            font-size: 0.1rem;
            color: #6c6c6c;
            font-style: normal;
            text-decoration: line-through;
            margin-left: 0.04rem;
          }
        }
      }
    }
  }
}
.nodata {
  background: #fff;
  padding-top: 0.4rem;
  padding-bottom: 0.19rem;
  img {
    width: 0.88rem;
    height: 0.88rem;
    margin: 0 auto;
  }
  .msg {
    font-size: 0.14rem;
    line-height: 0.2rem;
    margin-top: 0.14rem;
    color: #292929;
    text-align: center;
  }
  .gobtn {
    margin: 0 auto;
    margin-top: 0.16rem;
    width: 1.09rem;
    height: 0.36rem;
    border: solid 1px #fc0324;
    border-radius: 0.2rem;
    font-size: 0.14rem;
    line-height: 0.34rem;
    text-align: center;
    color: #fc0324;
  }
}
.noScroll {
  height: 100%;
  overflow: hidden;
}
.searchkeylist {
  position: fixed;
  width: 100%;
  height: calc(100vh);
  z-index: 1;
  color: #333;
  background: #f5f5f5;
  ul {
    overflow-y: auto;
    height: calc(100vh - 0.6rem);
  }
  li {
    line-height: 0.3rem;
    background: #ffffff;
    position: relative;
    padding: 0 0.15rem;
    &:active {
      background: #eee;
    }
    &::after {
      content: '';
      display: block;
      height: 0.005rem;
      background: #ccc;
      position: absolute;
      left: 0.15rem;
      right: 0.15rem;
      bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/searchItemList.vue